module.exports = __webpack_public_path__ + "img/P14.7717cf40.png";